import React from 'react';
import { useSelector } from 'react-redux';
import Collapsible from 'automaailm-ui/lib/Components/Collapsible';
import { CollapsibleHeader } from 'automaailm-ui/lib/Components/CollapsibleHeader';
import { CollapsibleBody } from 'automaailm-ui/lib/Components/CollapsibleBody';
import FormRow from 'automaailm-ui/lib/Components/FormRow';
import FormRowGroup from 'automaailm-ui/lib/Components/FormRowGroup';
import Button from 'automaailm-ui/lib/Components/Button';
import { IVehicle } from 'components/SearchBlock/CarSearch/CarSearchBlock';

export interface IVehicleIndicatorLabels {
    plate: string;
    make: string;
    model: string;
    motor: string;
    year: string;
    displacement: string;
    power: string;
    code: string;
    nextCheck: string;
    change: string;
}

interface IProps {
    config: {
        labels: IVehicleIndicatorLabels;
        searchUrl: string;
    };
}

const mapStateToProps = (state) => state.selectedVehicleReducer.selectedVehicle as IVehicle;

const VehicleIndicator = (props: IProps) => {
    const { labels, searchUrl } = props.config;
    const selectedVehicle = useSelector(mapStateToProps);

    if (!selectedVehicle?.type?.id) {
        return null;
    }

    const { licence, manufacturer, model, type, year, displacement, power, engineCode, nextCheck } = selectedVehicle;

    const summary = [licence, manufacturer?.label, model?.label, type?.label].filter(Boolean).join(' · ');

    const specs = [
        { label: labels.plate, value: licence },
        { label: labels.make, value: manufacturer?.label },
        { label: labels.model, value: model?.label },
        { label: labels.motor, value: type?.label },
        { label: labels.year, value: year },
        { label: labels.displacement, value: displacement },
        { label: labels.power, value: power },
        { label: labels.code, value: engineCode },
        { label: labels.nextCheck, value: nextCheck },
    ].filter((spec) => spec.value);

    return (
        <Collapsible className="vehicle-indicator">
            <CollapsibleHeader title={summary} />
            <CollapsibleBody>
                <FormRowGroup>
                    {specs.map((spec) => (
                        <FormRow key={spec.label} label={spec.label} value={spec.value} />
                    ))}
                </FormRowGroup>
                <Button type="anchor" href={searchUrl} layout="link" title={labels.change} />
            </CollapsibleBody>
        </Collapsible>
    );
};

export default VehicleIndicator;
